import api from '@/services/Api';

class TransportPackageService {
  async getTransportPackage(repairFileBoomerangId) {
    const url = '/distributor/get-transport-package-by-repair-file-boomerang-id/' + repairFileBoomerangId
    const response = await api.get(url)
    return response.data
  }
}

export default new TransportPackageService()
